import { createFileRoute } from "@tanstack/react-router";
import { AdminProductPage } from "../components/shop/admin-product-page.tsx";

export const Route = createFileRoute("/produkter/$productId")({ component: Screen });

function Screen() {
  const { productId } = Route.useParams();
  return <AdminProductPage productId={productId} />;
}
